import clsx from 'clsx';
import React, { FC, ReactNode } from 'react';

import styles from './SvgWrapper.module.css';

type SVGWrapperProps = {
  label: string;
  size: string;
  color?: string;
  width?: string;
  height?: string;
  className?: string;
  children?: ReactNode;
};

export const SVGWrapper: FC<SVGWrapperProps> = ({
  // component,
  className = '',
  size,
  width,
  height,
  color,
  children
}: SVGWrapperProps) => {
  // const WrappedComponent = component;
  return (
    <div
      className={clsx(styles.wrapper, 'bc-svgWrapper', className)}
      style={{
        '--svgWrapper-w': width || size,
        '--svgWrapper-h': height || size,
        '--svgWrapper-color': color
      }}
    >
      {children}
    </div>
  );
};
